// extracted by mini-css-extract-plugin
export default {"table":"Shelf_table__LtGTD"};